/*
  Product comparison - up to four products side by side, no customer account.
  (snippets/kx-compare-head.liquid has the markup contract and the owner's request.)

  The list is product handles in localStorage, like the favourites (KxFav in kalipso.js), so
  it belongs to one browser. A comparison can still be sent to someone: the page's
  "Копирай линк" puts the handles in ?p=a,b,c and opening that link loads them.

  The page (sections/kalipso-compare.liquid) is drawn here: each product's column is fetched
  from /products/<handle>?section_id=kalipso-compare-item - the site's own product card plus
  its facts as [label, value] pairs - and the rows are the union of all the labels, in the
  order the products list them. A row whose values are not all the same is a difference.
*/
(function () {
  'use strict';
  var KEY = 'kx:compare', MAX = 4;
  var PAGE_URL = window.KX_CMP_URL || '/pages/favourites?view=compare';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var mem = null;                      // the list when localStorage is unavailable (private mode)

  function clean(v) {
    var out = [];
    (Array.isArray(v) ? v : []).forEach(function (h) {
      if (typeof h === 'string' && h && out.indexOf(h) === -1 && out.length < MAX) out.push(h);
    });
    return out;
  }
  function read() {
    if (mem) return mem.slice();
    try { return clean(JSON.parse(localStorage.getItem(KEY))); } catch (e) { return []; }
  }
  function write(list) {
    list = clean(list);
    try { localStorage.setItem(KEY, JSON.stringify(list)); mem = null; } catch (e) { mem = list; }
    document.dispatchEvent(new CustomEvent('kx:cmp:change', { detail: { list: list } }));
  }
  var KxCmp = {
    max: MAX,
    all: read,
    has: function (h) { return read().indexOf(h) !== -1; },
    count: function () { return read().length; },
    // 'added' | 'full' | 'dup'
    add: function (h) {
      var l = read();
      if (l.indexOf(h) !== -1) return 'dup';
      if (l.length >= MAX) return 'full';
      l.push(h); write(l); return 'added';
    },
    remove: function (h) { var l = read(), i = l.indexOf(h); if (i !== -1) { l.splice(i, 1); write(l); } },
    removeMany: function (hs) {
      var before = read(), l = before.filter(function (h) { return hs.indexOf(h) === -1; });
      if (l.length !== before.length) write(l);
    },
    set: function (l) { write(l); },
    clear: function () { write([]); }
  };
  window.KxCmp = KxCmp;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function onPage() { return !!document.querySelector('[data-kx-cmp-page]'); }

  // ---- buttons, header icon -----------------------------------------------------------
  function paint() {
    var list = read();
    Array.prototype.forEach.call(document.querySelectorAll('[data-kx-cmp]'), function (btn) {
      var on = list.indexOf(btn.getAttribute('data-kx-cmp')) !== -1;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? 'Премахни от сравнението' : 'Добави за сравнение';
      if (btn.hasAttribute('aria-label')) btn.setAttribute('aria-label', label);
      if (btn.hasAttribute('title')) btn.setAttribute('title', label);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-kx-cmp-count]'), function (el) { el.textContent = list.length; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-kx-cmp-link]'), function (el) { el.hidden = list.length === 0; });
  }

  // ---- the note after a click: what happened, and the way to the page -------------------
  var toastEl = null, toastTimer = 0;
  function toast(text, linkText) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'kx-cmp-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<span></span><a href="' + esc(PAGE_URL) + '"></a><button type="button" aria-label="Затвори">×</button>';
      toastEl.querySelector('button').addEventListener('click', function () { toastEl.classList.remove('is-on'); });
      document.body.appendChild(toastEl);
      toastEl.offsetWidth;             // so the first show animates too
    }
    toastEl.querySelector('span').textContent = text;
    toastEl.querySelector('a').textContent = linkText;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 6500);
  }

  // ---- the dock: what has been added, on the right edge of the page -----------------------
  // Owner, 2026-10-06: "I want to see on the right of the page the products that I have added
  // for comparison while I am still in the collection page."
  // A slim strip of photos in the page's right gutter (it must not cover the cards - their
  // heart and compare buttons sit at the cards' right edge); it opens to names, a remove
  // button each and "Изчисти" on hover, on focus, by its head button, and by itself for a few
  // seconds after a product is added. Shown on wide screens, on pages that have a compare
  // button; phones keep the note at the bottom and the header icon.
  var dock = null, dockTimer = 0, META_KEY = 'kx:compare:meta', metaReq = {};
  var meta = (function () { try { return JSON.parse(sessionStorage.getItem(META_KEY)) || {}; } catch (e) { return {}; } })();
  var wide = window.matchMedia ? window.matchMedia('(min-width:990px)') : { matches: false };
  function metaSave() { try { sessionStorage.setItem(META_KEY, JSON.stringify(meta)); } catch (e) {} }
  function dockAllowed() { return !onPage() && !!document.querySelector('[data-kx-cmp]'); }
  function dockVisible() { return wide.matches && dockAllowed() && read().length > 0; }
  // name and photo: from the product's card when it is on this page, else from /products/<handle>.js
  function fromCard(h) {
    var found = null;
    Array.prototype.some.call(document.querySelectorAll('.kx-tile-wrap [data-kx-cmp]'), function (b) {
      if (b.getAttribute('data-kx-cmp') !== h) return false;
      var w = b.closest('.kx-tile-wrap'), img = w.querySelector('img'), a = w.querySelector('a.kx-tile');
      found = { t: w.getAttribute('data-kx-name') || '', img: img ? (img.currentSrc || img.src || '') : '', url: a ? a.getAttribute('href') : '' };
      return true;
    });
    return found && found.t ? found : null;
  }
  function need(h) {
    if (meta[h]) return;
    var c = fromCard(h);
    if (c) { meta[h] = c; metaSave(); return; }
    if (metaReq[h]) return;
    metaReq[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var img = p.featured_image || '';
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=160';
        meta[h] = { t: p.title || '', img: img, url: p.url || '' };
        metaSave(); drawDock();
      })
      .catch(function () {});
  }
  function drawDock() {
    var list = read();
    if (!list.length || !dockAllowed()) { if (dock) dock.classList.remove('is-on', 'is-open'); return; }
    if (!dock) {
      dock = document.createElement('aside');
      dock.className = 'kx-cmpdock';
      dock.setAttribute('aria-label', 'Продукти за сравнение');
      dock.addEventListener('click', function (e) {
        if (e.target.closest('.kx-cmpdock__head')) { clearTimeout(dockTimer); dock.classList.toggle('is-open'); }
      });
      document.body.appendChild(dock);
    }
    list.forEach(need);
    var h = '<button type="button" class="kx-cmpdock__head" aria-label="Сравнение - ' + list.length + ' от ' + MAX + ' продукта"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2"/></svg>' +
            '<span class="kx-cmpdock__more"><span class="kx-cmpdock__title">Сравнение</span></span>' +
            '<span class="kx-cmpdock__n"><b>' + list.length + '</b>/' + MAX + '</span></button><ul class="kx-cmpdock__list">';
    list.forEach(function (hd) {
      var m = meta[hd] || {};
      h += '<li class="kx-cmpdock__row"><a class="kx-cmpdock__item" href="' + esc(m.url || ROOT + 'products/' + encodeURIComponent(hd)) + '" title="' + esc(m.t || '') + '">' +
           '<span class="kx-cmpdock__thumb"' + (m.img ? ' style="background-image:url(&quot;' + esc(m.img) + '&quot;)"' : '') + '></span>' +
           '<span class="kx-cmpdock__more"><span class="kx-cmpdock__name">' + esc(m.t || '') + '</span></span></a>' +
           '<button type="button" class="kx-cmpdock__x" data-kx-cmp-remove="' + esc(hd) + '" aria-label="Премахни от сравнението">×</button></li>';
    });
    for (var i = list.length; i < MAX; i++) h += '<li class="kx-cmpdock__row kx-cmpdock__row--slot" aria-hidden="true"><span class="kx-cmpdock__thumb"></span></li>';
    h += '</ul><a class="kx-cmpdock__go" href="' + esc(PAGE_URL) + '" aria-label="Сравни"><span>Сравни</span></a>' +
         '<button type="button" class="kx-cmpdock__clear" data-kx-cmp-clear>Изчисти</button>';
    dock.innerHTML = h;
    dock.classList.add('is-on');
    fitDock();
  }
  // The closed strip must fit the free margin right of the page's content, and that margin is
  // not the same on every template (a product page is narrower than a category page). So the
  // photo size is measured: margin minus the strip's own padding, within 34-56 px.
  function fitDock() {
    if (!dock) return;
    var vw = document.documentElement.clientWidth, right = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.kx-tile-wrap, .kxpr-top, .kxpr-details'), function (c) {
      var r = c.getBoundingClientRect();
      if (r.width > 0 && r.right <= vw && r.right > right) right = r.right;
    });
    if (!right) { dock.style.removeProperty('--t'); dock.classList.remove('is-slim'); return; }
    var t = Math.max(34, Math.min(56, Math.floor(vw - right - 16)));
    dock.style.setProperty('--t', t + 'px');
    dock.classList.toggle('is-slim', t < 46);          // no room for the word "Сравни" - an arrow
  }
  if (window.addEventListener) window.addEventListener('resize', function () { if (dock && dock.classList.contains('is-on')) fitDock(); });
  // After an add the dock opens by itself for a moment - unless it would open over the pointer
  // (a card in the last column): then it would sit on the very buttons being used and, hovered,
  // stay there. In that case it only flashes; the new photo in the strip is the confirmation.
  function openDock(e) {
    if (!dock) return;
    var r = dock.getBoundingClientRect();
    if (e && e.clientX > window.innerWidth - 300 && e.clientY > r.top - 30 && e.clientY < r.bottom + 30) {
      dock.classList.remove('is-flash');
      dock.offsetWidth;                // restart the animation
      dock.classList.add('is-flash');
      return;
    }
    dock.classList.add('is-open');
    clearTimeout(dockTimer);
    dockTimer = setTimeout(function () { dock.classList.remove('is-open'); }, 4500);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var btn = t.closest('[data-kx-cmp]');
    if (btn) {
      e.preventDefault();              // on a card the button overlaps the card's link
      e.stopPropagation();
      var h = btn.getAttribute('data-kx-cmp');
      if (KxCmp.has(h)) { KxCmp.remove(h); return; }
      var r = KxCmp.add(h), n = KxCmp.count();
      if (onPage()) return;
      if (r === 'full') toast('Сравняват се до ' + MAX + ' продукта. Премахнете един, за да добавите нов.', 'Към сравнението');
      else if (dockVisible()) openDock(e);           // the dock shows what was added - no second note
      else if (n === 1) toast('Добавено за сравнение. Изберете още един продукт.', 'Сравнение');
      else toast('Добавено за сравнение - ' + n + ' от ' + MAX + ' продукта.', 'Сравни');
      return;
    }
    var rm = t.closest('[data-kx-cmp-remove]');
    if (rm) { e.preventDefault(); KxCmp.remove(rm.getAttribute('data-kx-cmp-remove')); return; }
    if (t.closest('[data-kx-cmp-clear]')) { e.preventDefault(); KxCmp.clear(); }
  });

  // ---- the comparison page --------------------------------------------------------------
  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/\s+/g, ' ').trim(); }

  // The same fact is labelled differently on different manufacturers' data sheets, and two
  // labels never share a row. The few that matter on every comparison are brought to one name;
  // where the label carried a detail (the order of the dimensions, the unit) it moves to the value.
  function canon(k, v) {
    var m = /^Размери\s*\((.+)\)$/.exec(k);
    if (m) return ['Размери', v + ' (' + m[1].trim() + ')'];
    if (k === 'Вид монтаж') return ['Монтаж', v];
    if (k === 'Тегло (kg)') return ['Нето тегло', /[a-zа-я]/i.test(v) ? v : v + ' kg'];
    return [k, v];
  }

  // rows = every label any product has, kept in the products' own order: a label new to the
  // list goes right after the label that precedes it on the product that brought it
  function mergeRows(items) {
    var order = [];
    items.forEach(function (it) {
      var prev = -1;
      it.labels.forEach(function (label) {
        var at = order.indexOf(label);
        if (at === -1) { order.splice(prev + 1, 0, label); at = prev + 1; }
        prev = at;
      });
    });
    return order.map(function (label) {
      var vals = items.map(function (it) { return it.map[label] || ''; });
      var first = norm(vals[0]);
      var same = vals.every(function (v) { return v && norm(v) === first; });
      return { label: label, vals: vals, same: same };
    });
  }

  function initPage() {
    var page = document.querySelector('[data-kx-cmp-page]');
    if (!page) return;
    var empty = page.querySelector('[data-kx-cmp-empty]');
    var body = page.querySelector('[data-kx-cmp-body]');
    var tools = page.querySelector('[data-kx-cmp-tools]');
    var count = page.querySelector('[data-kx-cmp-headcount]');
    var diffBox = page.querySelector('[data-kx-cmp-diff]');
    var diffWrap = page.querySelector('[data-kx-cmp-diffwrap]');
    var share = page.querySelector('[data-kx-cmp-share]');
    var hint = page.querySelector('[data-kx-cmp-hint]');

    // a shared link: ?p=handle,handle - it becomes this browser's list and leaves the address bar
    try {
      var qs = new URLSearchParams(location.search);
      if (qs.get('p')) {
        KxCmp.set(qs.get('p').split(',').map(function (s) { return s.trim(); }));
        qs.delete('p');
        var rest = qs.toString();
        history.replaceState(null, '', location.pathname + (rest ? '?' + rest : ''));
      }
    } catch (e) {}

    var cache = {};
    function load(h) {
      if (!cache[h]) {
        cache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=kalipso-compare-item', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var it = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.kx-cmp-item');
            if (!it) return null;
            var pairs = [];
            try { pairs = JSON.parse(it.querySelector('.kx-cmp-item__specs').textContent) || []; } catch (e) {}
            var map = {}, labels = [];
            pairs.forEach(function (p) {
              var kv = canon(String(p[0] || '').trim(), String(p[1] || '').trim()), k = kv[0], v = kv[1];
              if (!k || !v || map[k]) return;          // first value of a label wins
              map[k] = v; labels.push(k);
            });
            return { handle: h, title: it.getAttribute('data-title') || '', url: it.getAttribute('data-url') || '#',
                     card: it.querySelector('.kx-cmp-item__card'), map: map, labels: labels };
          })
          .catch(function () { return null; });
      }
      return cache[h];
    }

    function build(items) {
      var n = items.length, slot = n < MAX;
      var rows = mergeRows(items);
      var diffs = rows.filter(function (r) { return !r.same; }).length;
      var h = '<table class="kxcmp__table" style="--cols:' + n + ';--slot:' + (slot ? 1 : 0) + '"><colgroup><col class="kxcmp__lc">';
      items.forEach(function () { h += '<col class="kxcmp__pc">'; });
      if (slot) h += '<col class="kxcmp__pc kxcmp__pc--slot">';
      h += '</colgroup><thead><tr class="kxcmp__cards"><td class="kxcmp__corner"></td>';
      items.forEach(function (it, i) {
        h += '<th scope="col" class="kxcmp__col" data-col="' + i + '"></th>';
      });
      if (slot) h += '<td class="kxcmp__slot" rowspan="2"><div class="kxcmp__slotbox"><b>+</b><span>Добавете още продукт</span><small>с бутона за сравнение върху него</small></div></td>';
      // the buttons are a row of their own, so they line up under cards of different heights
      h += '</tr><tr class="kxcmp__actsrow"><td class="kxcmp__corner"></td>';
      items.forEach(function (it) {
        h += '<td><div class="kxcmp__acts"><a class="kxcmp__go" href="' + esc(it.url) + '">Към продукта</a>' +
             '<button type="button" class="kxcmp__remove" data-kx-cmp-remove="' + esc(it.handle) + '">Премахни</button></div></td>';
      });
      h += '</tr></thead><tbody>';
      rows.forEach(function (r) {
        h += '<tr class="' + (n > 1 ? (r.same ? 'is-same' : 'is-diff') : '') + '"><th scope="row"><span>' + esc(r.label) + '</span></th>';
        r.vals.forEach(function (v) { h += '<td>' + (v ? esc(v) : '<span class="kxcmp__na">-</span>') + '</td>'; });
        if (slot) h += '<td class="kxcmp__pad"></td>';
        h += '</tr>';
      });
      if (!rows.length) h += '<tr><th scope="row"></th><td colspan="' + (n + (slot ? 1 : 0)) + '" class="kxcmp__na">За тези продукти няма въведени характеристики.</td></tr>';
      h += '</tbody></table>';
      body.innerHTML = h;
      items.forEach(function (it, i) {
        var cell = body.querySelector('[data-col="' + i + '"]');
        if (it.card) cell.appendChild(it.card.cloneNode(true));
      });
      var table = body.querySelector('.kxcmp__table');
      // phone: with three or four products the columns narrow a little, so the next one peeks in
      var wrap = page.querySelector('.kxcmp__wrap');
      if (wrap) { if (n > 2) wrap.setAttribute('data-many', ''); else wrap.removeAttribute('data-many'); }
      var mixed = n > 1 && diffs > 0 && diffs < rows.length;     // some rows differ, some do not
      table.classList.toggle('is-diffonly', !!(diffBox && diffBox.checked && mixed));
      table.classList.toggle('is-mixed', mixed);                 // only then is marking a difference worth it
      if (diffWrap) diffWrap.hidden = !mixed;
      // the names again, in a bar that slides in once the cards have scrolled away
      stick.innerHTML = '<div class="kxcmp__stickin" style="--cols:' + n + '"><span></span>' +
        items.map(function (it) { return '<span>' + esc(it.title) + '</span>'; }).join('') + '</div>';
      place();
      if (hint) hint.hidden = !slot;
      paint();
      document.dispatchEvent(new CustomEvent('kx:fav:painted'));   // the cards' hearts (kalipso.js)
    }

    var stick = document.createElement('div');
    stick.className = 'kxcmp__stick';
    stick.setAttribute('aria-hidden', 'true');
    body.parentNode.insertBefore(stick, body.nextSibling);
    var ticking = false;
    function place() {
      ticking = false;
      var table = body.querySelector('.kxcmp__table'), acts = table && table.querySelector('.kxcmp__actsrow');
      if (!acts || !stick.firstChild) { stick.classList.remove('is-on'); return; }
      var tr = table.getBoundingClientRect();
      stick.firstChild.style.marginLeft = Math.round(tr.left) + 'px';
      stick.classList.toggle('is-on', acts.getBoundingClientRect().bottom < 0 && tr.bottom > 140);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(place); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    body.addEventListener('scroll', onScroll, { passive: true });

    var seq = 0;
    function render() {
      var list = KxCmp.all(), token = ++seq;
      if (count) count.textContent = list.length ? list.length + ' от ' + MAX : '';
      if (!list.length) {
        empty.hidden = false; body.hidden = true; body.innerHTML = '';
        stick.innerHTML = ''; stick.classList.remove('is-on');
        if (tools) tools.hidden = true;
        if (hint) hint.hidden = true;
        return;
      }
      empty.hidden = true; body.hidden = false;
      if (tools) tools.hidden = false;
      body.setAttribute('aria-busy', 'true');
      Promise.all(list.map(load)).then(function (items) {
        if (token !== seq) return;                       // the list changed while loading
        var gone = list.filter(function (h, i) { return !items[i]; });
        if (gone.length) {                               // deleted or unpublished since it was added
          gone.forEach(function (h) { delete cache[h]; });
          KxCmp.removeMany(gone);
          return;
        }
        build(items);
        body.removeAttribute('aria-busy');
      });
    }

    if (diffBox) diffBox.addEventListener('change', function () {
      var t = body.querySelector('.kxcmp__table');
      if (t) t.classList.toggle('is-diffonly', diffBox.checked && t.classList.contains('is-mixed'));
    });
    if (share) share.addEventListener('click', function () {
      var u = new URL(location.href);
      u.searchParams.set('p', KxCmp.all().join(','));
      var link = u.toString(), was = share.textContent;
      function done() { share.textContent = 'Линкът е копиран'; setTimeout(function () { share.textContent = was; }, 2200); }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(done, function () { window.prompt('Линк към сравнението:', link); });
      else window.prompt('Линк към сравнението:', link);
    });
    document.addEventListener('kx:cmp:change', render);
    render();
  }

  document.addEventListener('kx:cmp:change', paint);
  document.addEventListener('kx:cmp:change', drawDock);
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) document.dispatchEvent(new CustomEvent('kx:cmp:change', { detail: { list: read() } }));
  });
  // cards drawn after load (favourites page, predictive lists) need their state too
  document.addEventListener('kx:fav:painted', paint);
  document.addEventListener('kx:fav:painted', drawDock);

  function start() { paint(); initPage(); drawDock(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
